import React from 'react';
import { observer } from 'mobx-react';

import { HomeNavbar } from '../../common/home-navbar';
import { RadioBullet } from '../../common/radio-bullet';
import { USER_TYPES } from '../../models/User';
import { AppRedirect, routeNaming } from '../../routes';
import { SessionStore } from '../../stores/SessionStore';
import { DataForm } from './data-form';
import styles from './Register.css';
import { SEO } from '../../common/seo';

const Register = observer(class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedType: USER_TYPES.PERSON,
    };

    this._updateSelectedType = this._updateSelectedType.bind(this);
  }

  _updateSelectedType(type) {
    this.setState({
      selectedType: type,
    });
  }

  render() {
    if (SessionStore.loggedIn) {
      return (
        <AppRedirect routeName={routeNaming.LOGIN_VALIDATOR} />
      );
    }
    return (
      <div className={styles.container}>
        <SEO
          title="Registro"
          description="Regístrate para acceder a todas nuestras funcionalidades y beneficios exclusivos. Al crear una cuenta, podrás gestionar tus preferencias, realizar compras, guardar tus favoritos y recibir actualizaciones personalizadas. Completa el proceso de registro de manera rápida y segura para disfrutar de una experiencia optimizada y sin interrupciones. Únete hoy a nuestra comunidad y empieza a disfrutar de todas las ventajas que ofrecemos en Carlos Gutiérrez S.A."
          type="website"
        />
        <HomeNavbar />
        <div className={styles.mainContent}>
          <h1 className={styles.title}>
            Crear tu cuenta
          </h1>
          <div className={styles.bulletContainer}>
            <RadioBullet
              className={styles.bullet}
              onClick={() => this._updateSelectedType(USER_TYPES.PERSON)}
              text="Persona"
              selected={this.state.selectedType === USER_TYPES.PERSON}
            />
            <RadioBullet
              className={styles.bullet}
              onClick={() => this._updateSelectedType(USER_TYPES.UNIPERSONAL)}
              text="Unipersonal"
              selected={this.state.selectedType === USER_TYPES.UNIPERSONAL}
            />
            <RadioBullet
              className={styles.bullet}
              onClick={() => this._updateSelectedType(USER_TYPES.COMPANY)}
              text="Empresa"
              selected={this.state.selectedType === USER_TYPES.COMPANY}
            />
          </div>
          <DataForm
            className={styles.form}
            userType={this.state.selectedType}
          />
        </div>
      </div>
    );
  }
});

export { Register };



// WEBPACK FOOTER //
// ./src/pages/register/Register.jsx